export default "__VITE_ASSET__3aca6d03__"